import React from 'react';

const Search = ({ className }: { className?: string }) => {
	return (
		<svg
			className={className}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 19.996 20">
			<path
				d="M19.725 17.291 15.83 13.4a.937.937 0 0 0-.664-.273h-.636a8.12 8.12 0 1 0-1.406 1.406v.637a.937.937 0 0 0 .273.664l3.894 3.894a.934.934 0 0 0 1.324 0l1.105-1.105a.942.942 0 0 0 0-1.328Zm-11.6-4.168a5 5 0 1 1 5-5 5 5 0 0 1-5.001 5.001Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default Search;
